import { Search, X, Trash2 } from "lucide-react";
import { statusFilters } from "./jobConstants";

const JobsToolbar = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusChange,
  selectedCount,
  isDeleting,
  onBulkDelete,
  onClearSelection,
  totalJobs,
  statusCounts = {},
}) => (
  <div className="sz-card p-[14px_16px]" style={{ boxShadow: "0 1px 0 rgba(12,17,32,.02)" }}>
    {/* Search row */}
    <div className="flex items-center gap-3 flex-wrap">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A8AEBC]" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search title, ID, owner, location or crew…"
          className="sz-input pl-9 pr-9"
        />
        {searchQuery && (
          <button onClick={() => onSearchChange("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#A8AEBC] hover:text-[#0C1120]">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* Status filter pills */}
      <div className="flex gap-1.5 overflow-x-auto szscroll">
        {statusFilters.map((f) => {
          const isActive = statusFilter === f.key;
          const count = f.key === "all" ? (statusCounts.all ?? totalJobs) : statusCounts[f.key];
          return (
            <button
              key={f.key}
              onClick={() => onStatusChange(f.key)}
              className={`sz-pill ${isActive ? "sz-active" : ""}`}
            >
              {f.label}
              {count !== undefined && count !== null && <span className="sz-pill-count">{count}</span>}
            </button>
          );
        })}
      </div>
    </div>

    {/* Bulk actions bar */}
    {selectedCount > 0 && (
      <div className="flex items-center justify-between mt-3 rounded-[11px] px-3 py-2" style={{ background: "#FEE2E2", border: "1px solid #FECACA" }}>
        <span className="text-sm font-semibold" style={{ color: "#B91C1C" }}>{selectedCount} selected</span>
        <div className="flex items-center gap-2">
          <button onClick={onClearSelection} className="text-xs font-semibold" style={{ color: "#B91C1C" }}>Clear</button>
          <button onClick={onBulkDelete} disabled={isDeleting} className="sz-btn sz-btn-danger py-1.5 px-3 text-xs">
            <Trash2 className="w-3.5 h-3.5" />
            {isDeleting ? "Deleting…" : "Delete"}
          </button>
        </div>
      </div>
    )}
  </div>
);

export default JobsToolbar;
